import { defineDirective } from "../../utils/angular";
import { isUndefined } from "../../utils/utils";

/** @internal */
export class DatePickerCtrl {

    static create(): ng.IDirective {

        var def = defineDirective(DatePickerCtrl, "shared/components/datepicker/datepicker.html", {
            "ngModel": "=",
            "ngChange": "&",
            "required": "=",
            "omniaRequired": "=",
            "datepickerAppendToBody": "=",
            "placeholder": "=",
            "ngFocus": "@",
            "disabled": "=",
            "initDate": "="
        });

        def.require = "ngModel";

        return def;

    }


    private datepickerAppendToBody: boolean;
    private ngFocusExpr: Function;

    ngChange: Function

    static $inject = ["$scope", "$parse", "$timeout"]

    constructor(private $scope: ng.IScope, private $parse: ng.IParseService, private $timeout: ng.ITimeoutService) {
        $scope.$watch("vm.ngFocus", f => this.setFocusExpression(f));
    }

    get appendToBody(): boolean {
        return isUndefined(this.datepickerAppendToBody) ? true : this.datepickerAppendToBody;
    }

    private setFocusExpression(f) {
        this.ngFocusExpr = this.$parse(f);
    }

    setFocus($event) {

        if (this.ngFocusExpr) {
            this.ngFocusExpr(this.$scope.$parent);
        }

    }

    notifyChange() {
        if (this.ngChange) {
            this.$timeout(() => this.ngChange())
        }
    }

}
